import { useEffect, useId, useRef, useState } from 'react';
import { Archive, EllipsisVertical, Trash2 } from 'lucide-react';
import type { ProcessoCartaoDto } from '@nexital/shared';
import { useAcoesEstado } from './AcoesEstado';

/** Menu ⋮ do cartão (RQ-EST-010, RQ-EST-011): Arquivar e Enviar à Lixeira, cada um com sua confirmação. */
export function MenuCartao({ processo }: { processo: ProcessoCartaoDto }) {
  const { arquivar, enviarLixeira } = useAcoesEstado();
  const [aberto, definirAberto] = useState(false);
  const raiz = useRef<HTMLDivElement>(null);
  const id = useId();

  useEffect(() => {
    if (!aberto) return;
    raiz.current?.querySelector<HTMLElement>('[role="menuitem"]')?.focus();
    const fora = (evento: PointerEvent) => {
      if (!raiz.current?.contains(evento.target as Node)) definirAberto(false);
    };
    document.addEventListener('pointerdown', fora);
    return () => document.removeEventListener('pointerdown', fora);
  }, [aberto]);

  const escolher = (acao: (p: ProcessoCartaoDto) => Promise<boolean>) => () => {
    definirAberto(false);
    void acao(processo);
  };

  return (
    // nodrag/nopan: o React Flow não inicia arraste nem seleção a partir do menu.
    <div
      ref={raiz}
      className="menu-cartao nodrag nopan"
      onKeyDown={(e) => {
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        definirAberto(false);
        raiz.current?.querySelector<HTMLElement>('button')?.focus();
      }}
    >
      <button
        type="button"
        className="menu-cartao__botao"
        aria-label={`Ações de ${processo.numero}`}
        aria-haspopup="menu"
        aria-expanded={aberto}
        aria-controls={aberto ? id : undefined}
        onClick={() => definirAberto(!aberto)}
      >
        <EllipsisVertical size={18} aria-hidden />
      </button>
      {aberto && (
        <div id={id} role="menu" className="menu-cartao__lista" aria-label={`Ações de ${processo.numero}`}>
          <button type="button" role="menuitem" onClick={escolher(arquivar)}>
            <Archive size={16} aria-hidden /> Arquivar…
          </button>
          <button type="button" role="menuitem" className="menu-cartao__perigo" onClick={escolher(enviarLixeira)}>
            <Trash2 size={16} aria-hidden /> Enviar à Lixeira…
          </button>
        </div>
      )}
    </div>
  );
}
